module.exports = __webpack_public_path__ + "static/media/spotify.16d526bc.jpg";